class Contact {
  constructor(el) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
      this.initDatePicker();
    }
  }

  event() {
    const $radios = $('.js-contact-type input[type="radio"]');

    function toggleExtra() {
      $('[data-id="js-contact-repair"], [data-id="js-contact-reserve"]').hide();

      const value = $('.js-contact-type input[type="radio"]:checked').val() || '';

      if (value === '来店予約') {
        $('[data-id="js-contact-reserve"]').show();
        // 来店予約が選択されたら、日時ピッカーを再初期化
        this.initDatePicker();
      }

      if (value === '修理について') {
        $('[data-id="js-contact-repair"]').show();
      }
    }

    $radios.on('change', toggleExtra.bind(this));
    toggleExtra.call(this);
  }

  initDatePicker() {
    // data-id="js-contact-reserve" 内のreserve_dateフィールドを探す（Contact Form 7の複数のパターンに対応）
    // パターン1: name属性にreserve_dateが含まれる
    // パターン2: wpcf7-form-control-wrap-reserve_dateクラス内のinput
    // パターン3: 直接name="reserve_date"
    let $reserveDateInput = $('[data-id="js-contact-reserve"] input[name="reserve_date"]');
    if ($reserveDateInput.length === 0) {
      $reserveDateInput = $('[data-id="js-contact-reserve"] input[name*="reserve_date"]');
    }
    if ($reserveDateInput.length === 0) {
      $reserveDateInput = $('[data-id="js-contact-reserve"] .wpcf7-form-control-wrap-reserve_date input[type="text"]');
    }
    
    if ($reserveDateInput.length > 0 && typeof flatpickr !== 'undefined') {
      const inputElement = $reserveDateInput[0];
      
      // 既に初期化されている場合は破棄
      if (inputElement._flatpickr) {
        inputElement._flatpickr.destroy();
      }

      // 日本語ロケール設定
      flatpickr.localize({
        firstDayOfWeek: 0,
        weekdays: {
          shorthand: ['日', '月', '火', '水', '木', '金', '土'],
          longhand: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日']
        },
        months: {
          shorthand: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          longhand: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
        }
      });

      // Flatpickrを初期化（1時間単位で時間選択）
      flatpickr(inputElement, {
        enableTime: true,
        dateFormat: 'Y-m-d H:i',
        time_24hr: true,
        locale: {
          firstDayOfWeek: 0,
          weekdays: {
            shorthand: ['日', '月', '火', '水', '木', '金', '土'],
            longhand: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日']
          },
          months: {
            shorthand: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
            longhand: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
          }
        },
        minDate: 'today',
        allowInput: false,
        minuteIncrement: 60, // 1時間単位（10:00, 11:00, 12:00...17:00）
        defaultHour: 10,
        defaultMinute: 0,
        minTime: '10:00',
        maxTime: '17:00',
        // 土日祝も選択可能（disableオプションを指定しない）
        onReady: function(selectedDates, dateStr, instance) {
          // カレンダーが表示されたときの処理
        }
      });
    }
  }
}